/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

var HISTORY_CLEAR_WAIT = 64 * 1000;
var RESPECT_HISTORY_WAIT = 32 * 1000;
var TAKE_WAIT = 48 * 1000;

module.exports = Model({
	name: "braceletreconnector",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_connectedHistory: null,
	_foundQueue: null,
	_shouldQueue: false,
	_shouldRespectHistory: null,
	_historyClearer: null,
	_nextTimer: null,
	_takingBy: null,
	_available: null,

	beginReconnect: beginReconnect,
	stopReconnect: stopReconnect,

	tellTake: tellTake,
	doFirst: doFirst,
	doNext: doNext,
	addQueue: addQueue,

	scheduleNext: scheduleNext,
	clearNext: clearNext,
	scheduleClearHistory: scheduleClearHistory,
	unscheduleClearHistory: unscheduleClearHistory,
	scheduleDisrespectHistory: scheduleDisrespectHistory,

	isAvailable: isAvailable,
});

function init() {
	this._connectedHistory = [];
	this._available = [];
	this.push(false);
}

function uninit() {
	clearTimeout(this._shouldRespectHistory);
	clearTimeout(this._historyClearer);
	clearTimeout(this._nextTimer);
}

function triggers() {
	return {
		"find": beginReconnect,
		"stop": stopReconnect
	};
}

function listeners() {
	return {
		"machineevents:found": handle_found,
		"machineevents:taken": handle_taken,
		"machineevents:failed": handle_failed,
		"availablemachines:updated": handle_available_machine_updated,
	};
}

/**
 * This object retains the mac and model of the bracelet being reconnected
 * @param {Object} data Contains attributes 'mac' and 'model'
 */
function beginReconnect(data) {
	var bracelet = data.bracelet;
	var model = data.model;

	if (!bracelet) return;
	if (model !== "vlrt") return;

	if (this.data) return;

	this._foundQueue = [];

	this.push({
		bracelet: bracelet,
		model: model
	});

	this.unscheduleClearHistory();
	this.scheduleDisrespectHistory();

	this.emit("braceletfindevents:trigger:find", data);
}

function stopReconnect() {
	if (!this.data) return;

	this.emit("braceletfindevents:trigger:finish");

	this._shouldQueue = false;
	this._takingBy = null;

	this.clearNext();

	this.push(false);
}

function handle_found(data) {
	var reconnectingBracelet = this.data.bracelet;
	var bracelet = data.bracelet;
	var machine = data.from;

	// If we aren't reconnecting, tell them to stop
	if (!reconnectingBracelet)
		return this.emit("braceletfindevents:trigger:finish:one", {
			machine: machine,
			bracelet: bracelet
		});

	// If they found someone else's bracelet, ignore the message
	if (bracelet !== reconnectingBracelet)
		return this.dispatch("ignored", {
			machine: machine,
			bracelet: bracelet,
			reason: "BAD_BRACELET"
		});

	// If we've connected to this device and didn't stay connected for long
	// Ignore it for a while
	if (
		(this._shouldRespectHistory) &&
		(this._connectedHistory.indexOf(machine) !== -1)
	) return this.dispatch("ignored", {
		machine: machine,
		bracelet: bracelet,
		reason: "BAD_CONNECTION"
	});

	// If we're waiting on a taken event to happen, queue this found up
	if (this._shouldQueue)
		return this.addQueue(data);

	// Must be the first found, take it
	this.doFirst(machine);
}

function tellTake(machine) {
	var bracelet = this.data.bracelet;
	var model = this.data.model;
	var task = this.data.task;

	if (!model) model = "vlrt";
	if (!task) task = null;

	var triggerData = {
		machine: machine,
		bracelet: bracelet,
		model: model
	};

	// Save who last recieved the take
	this._takingBy = machine;

	this.emit("machineevents:trigger:take", triggerData);

	this.dispatch("taking", triggerData);

	this.scheduleNext();
}

function handle_taken(data) {
	var currentBracelet = this.data;
	var bracelet = data.bracelet;
	var machine = data.from;
	var history = this._connectedHistory;

	if (!currentBracelet) return;

	if (bracelet !== currentBracelet.bracelet) return;

	this.stopReconnect();
	this.scheduleClearHistory();

	if (history.indexOf(machine) !== -1) return;
	this._connectedHistory.push(machine);
}

function handle_failed(data) {
	var from = data.from;
	var bracelet = data.bracelet;
	if (bracelet !== this.data) return;
	if (from !== this._takingBy) return;
	this.doNext();
}

function doFirst(machine) {
	this._shouldQueue = true;
	this.tellTake(machine);
}

function addQueue(data) {
	var machine = data.from;
	var queue = this._foundQueue;

	var hasUpdated = false;
	var updatedQueue = queue.map(function (item) {
		if (item.from !== machine) return item;
		hasUpdated = true;
		return data;
	});

	if (!hasUpdated)
		updatedQueue.push(data);

	var sortedQueue = updatedQueue.sort(function (a, b) {
		if (a.rssi > b.rssi) return -1;
		if (a.rssi < b.rssi) return 1;
		return 0;
	});

	this._foundQueue = sortedQueue;
}

function doNext() {
	var queue = this._foundQueue;

	if (!queue.length) {
		this._shouldQueue = false;
		return;
	}

	var nextData = queue.shift();

	var from = nextData.from;

	if (!this.isAvailable(from))
		return this.doNext();

	this.tellTake(nextData.from);
}

function scheduleNext() {
	this.clearNext();
	this._nextTimer = setTimeout(doNext.bind(this), TAKE_WAIT);
}

function clearNext() {
	clearTimeout(this._nextTimer);
}

function scheduleDisrespectHistory() {
	clearTimeout(this._shouldRespectHistory);
	this._shouldRespectHistory = setTimeout(disrespectHistory.bind(this), RESPECT_HISTORY_WAIT);
}

function disrespectHistory() {
	this._shouldRespectHistory = false;
}

function scheduleClearHistory() {
	clearTimeout(this._historyClearer);
	this._historyClearer = setTimeout(clearHistory.bind(this), HISTORY_CLEAR_WAIT);
}

function unscheduleClearHistory() {
	clearTimeout(this._historyClearer);
}

function clearHistory() {
	this._connectedHistory = [];
}

function handle_available_machine_updated(available) {
	this._available = available;
	var taker = this._takingBy;

	if (taker && !this.isAvailable(taker)) {
		this._takingBy = null;
		this.doNext();
	}
}

function isAvailable(machine) {
	return (this._available.indexOf(machine) !== -1);
}
